import { Action, createReducer, on } from "@ngrx/store";
import { EntityTramiteStatusState, entityTramiteStatusAdapter, initialState } from "./tramite-status.state";
import { tramiteStatusLoadRequest, tramiteStatusLoadSuccess } from "./tramite-status.actions";

const reducer = createReducer(
  initialState,
  on(tramiteStatusLoadRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(tramiteStatusLoadSuccess, (state, { items }) =>
    entityTramiteStatusAdapter.setAll(items, {
      ...state,
      isLoading: false,
      error: null
    })
  )
)

export function tramiteStatusReducer(
  state: EntityTramiteStatusState | undefined,
  action: Action
) {
  return reducer(state, action);
}
